import { StatusInscription } from '@/enum/StatusInscription';
import Vue from 'vue'

export const colorStatusInscription = (value: number) => {    
    switch(value){
        case StatusInscription.inscrit: return "#A6F562";
        case StatusInscription.present: return "#E758F5";
        case StatusInscription.abscent: return "#F5CA73";
        case StatusInscription.annulee: return "#F57F65";
        case StatusInscription.attente: return "#4C8EF5";
    }
    return "";     
}
Vue.filter('colorStatusInscription', colorStatusInscription)